import React, {
  PropTypes,
} from 'react'
import {
  compose,
  withState,
} from 'recompose'
import FormInput from 'components/forms/bases/FormInput'
import { Icon } from 'semantic-ui-react'

const EditableText = compose(
  withState('isEditing', 'setIsEditing', false),
  withState('currentValue', 'setCurrentValue', ''),
)(
  ({
    value,
    onChange,
    onDelete,
    placeholder,
    isEditing,
    hasRemoveItem,
    setIsEditing,
    currentValue,
    setCurrentValue,
  }) => {
    const handleEditClick = () => {
      // set value from data in state, in order to edit
      // set isEditing true
      setIsEditing(true)
      return setCurrentValue(value)
    }
    const handleEditSubmit = (e) => {
      e.preventDefault()
      // remove editor
      setIsEditing(false)
      // sent back new value
      return onChange(currentValue)
    }

    return (
      <form onSubmit={handleEditSubmit} style={{ zIndex: 1000 }}>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            padding: 12,
          }}
        >
          {isEditing ? (
            <FormInput
              placeholder={placeholder}
              value={currentValue}
              onChange={setCurrentValue}
              style={{
                maxWidth: 200,
              }}
            />
          ) : (
            <span>{value}</span>
          )}
          {isEditing ? (
            <span>
              <Icon
                size={'large'}
                color={'green'}
                name="check"
                onClick={handleEditSubmit}
                style={{ cursor: 'pointer' }}
              />
              <Icon
                size={'large'}
                color={'red'}
                name="delete"
                onClick={() => setIsEditing(false)}
                style={{ cursor: 'pointer' }}
              />
            </span>
          ) : (
            <span>
              <Icon
                size={'large'}
                name="pencil"
                onClick={handleEditClick}
                style={{ cursor: 'pointer' }}
              />
              { hasRemoveItem &&
                <Icon
                  size={'large'}
                  color={'red'}
                  name="trash"
                  onClick={onDelete}
                  style={{ cursor: 'pointer' }}
                />
              }
            </span>
          )}
        </div>
      </form>
    )
  }
)

EditableText.propTypes = {
  hasRemoveItem: PropTypes.bool,
}
EditableText.defaultProps = {
  hasRemoveItem: true,
}

export default EditableText



// WEBPACK FOOTER //
// ./src/components/forms/bases/EditableText.js